

export const DATA_TABLE_COLUMN_NUMBER = {
  FIRST: 0,
  SECOND: 1
};